import { useLazyQuery } from "@apollo/client/react";
import { useMemo } from "react";

import {
  SEARCH_MANAGED_ENTITIES_GROUP_BY_PROVIDERS,
  SEARCH_STACK_MANAGED_ENTITIES_GROUP_BY_PROVIDERS,
} from "./gql";

const useIacManagementProvidersGroups = (parentStackId?: string) => {
  const [
    accountLazyFetch,
    {
      data: accountData,
      previousData: accountPreviousData,
      loading: accountLoading,
      called: accountCalled,
    },
  ] = useLazyQuery(SEARCH_MANAGED_ENTITIES_GROUP_BY_PROVIDERS);

  const [
    stackLazyFetch,
    {
      data: stackData,
      previousData: stackPreviousData,
      loading: stackLoading,
      called: stackCalled,
    },
  ] = useLazyQuery(SEARCH_STACK_MANAGED_ENTITIES_GROUP_BY_PROVIDERS);

  const groups = useMemo(() => {
    if (parentStackId) {
      return (
        stackData?.stack?.searchManagedEntitiesGroupByProviders?.edges.map((edge) => edge.node) ||
        stackPreviousData?.stack?.searchManagedEntitiesGroupByProviders?.edges.map(
          (edge) => edge.node
        ) ||
        []
      );
    } else {
      return (
        accountData?.searchManagedEntitiesGroupByProviders?.edges.map((edge) => edge.node) ||
        accountPreviousData?.searchManagedEntitiesGroupByProviders?.edges.map(
          (edge) => edge.node
        ) ||
        []
      );
    }
  }, [
    parentStackId,
    stackData?.stack?.searchManagedEntitiesGroupByProviders?.edges,
    stackPreviousData?.stack?.searchManagedEntitiesGroupByProviders?.edges,
    accountData?.searchManagedEntitiesGroupByProviders?.edges,
    accountPreviousData?.searchManagedEntitiesGroupByProviders?.edges,
  ]);

  const accountDataIsEmpty =
    accountData &&
    "searchManagedEntitiesGroupByProviders" in accountData &&
    !groups.length &&
    !accountLoading;
  const stackDataIsEmpty = Boolean(
    stackData?.stack?.searchManagedEntitiesGroupByProviders && !groups.length && !stackLoading
  );

  const endCursor = parentStackId
    ? stackData?.stack?.searchManagedEntitiesGroupByProviders?.pageInfo.endCursor
    : accountData?.searchManagedEntitiesGroupByProviders?.pageInfo.endCursor;
  const startCursor = parentStackId
    ? stackData?.stack?.searchManagedEntitiesGroupByProviders?.pageInfo.startCursor
    : accountData?.searchManagedEntitiesGroupByProviders?.pageInfo.startCursor;

  return {
    lazyFetch: parentStackId ? stackLazyFetch : accountLazyFetch,
    groups,
    loading: parentStackId ? stackLoading : accountLoading,
    called: parentStackId ? stackCalled : accountCalled,
    endCursor,
    startCursor,
    dataIsEmpty: parentStackId ? stackDataIsEmpty : accountDataIsEmpty,
  };
};

export default useIacManagementProvidersGroups;
